import { render, staticRenderFns } from "./MppPromoter.vue?vue&type=template&id=256d4c94&scoped=true"
import script from "./MppPromoter.vue?vue&type=script&lang=js"
export * from "./MppPromoter.vue?vue&type=script&lang=js"
import style0 from "./MppPromoter.vue?vue&type=style&index=0&id=256d4c94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256d4c94",
  null
  
)

export default component.exports